import bearerTokenActions from "./bearerTokenActions";
import timeActions from "./timeActions";

const allActions = {
	bearerTokenActions,
	timeActions
};

export default allActions;